export default "__VITE_ASSET__BRtLACVI__"